// Zdieľaný PowerShell na vytvorenie self-signed certifikátu (.cer verejný + .pfx súkromný).
// Používajú ho CertHelpModal (aplikačný prístup) aj DelegatedHelpModal (prihlásenie používateľa).
// password = zástupný text hesla v príkaze (preložený, t('spHelpPsPassword')).
export const certPowershell = (password) => `$cert = New-SelfSignedCertificate -Subject "CN=SharePointAppCert" -CertStoreLocation "Cert:\\CurrentUser\\My" -KeyExportPolicy Exportable -KeySpec Signature
Export-Certificate -Cert $cert -FilePath ".\\SharePointAppCert.cer"
$pwd = ConvertTo-SecureString -String "<${password}>" -Force -AsPlainText
Export-PfxCertificate -Cert $cert -FilePath ".\\SharePointAppCert.pfx" -Password $pwd`;
